type FuelBarProps = {
  fuel: number;
  isLaunching: boolean;
};

export function FuelBar({ fuel, isLaunching }: FuelBarProps) {
  const clampedFuel = Math.min(100, Math.max(0, fuel));

  return (
    <section className="rr-panel rr-fuel-panel" aria-label="Rocket fuel">
      <div className="rr-fuel-header">
        <span>Rocket fuel</span>
        <strong>{clampedFuel}%</strong>
      </div>
      <div
        className="rr-fuel-track"
        role="meter"
        aria-label="Rocket fuel level"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={clampedFuel}
      >
        <div
          className={`rr-fuel-fill${isLaunching ? ' rr-fuel-fill-launching' : ''}`}
          style={{ width: `${clampedFuel}%` }}
        />
      </div>
      <p className="rr-fuel-caption">
        {isLaunching ? 'Launch power is glowing.' : 'Fill to 100 to visit the next planet.'}
      </p>
    </section>
  );
}
